import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import Hearts from '../../../components/hearts/hearts';
import Slider from '../../../components/slider/slider';
import Video from '../../../components/video/video';
import DataStore from '../../store/DataStore';

interface IDataStore {
  dataStore?: DataStore;
}

enum QuestionType {
  Slider = 'slider',
  Hearts = 'hearts'
}

interface IQuestion {
  id: number;
  type: QuestionType;
  src: string;
  nextSrc: string;
}
@observer
class Question extends React.Component<RouteProps & IQuestion & IDataStore> {
  static defaultProps = {
    type: QuestionType.Slider
  };

  constructor(props) {
    super(props);
    this.props.dataStore.setActiveQuestion(this.props.id);
  }

  render() {
    const { id, type, src, nextSrc, dataStore } = this.props;
    return (
      <React.Fragment>
        <Video src={src} nextSrc={nextSrc} />
        {type === QuestionType.Slider ? (
          <Slider
            defaultValue={dataStore.activeQuestionValue}
            onChange={value => dataStore.setActiveQuestionValue(id, value)}
          />
        ) : (
          <Hearts
            onChange={value => dataStore.setActiveQuestionValue(id, value)}
            defaultValue={dataStore.activeQuestionValue}
          />
        )}
      </React.Fragment>
    );
  }
}

export default inject('dataStore')(Question);



// WEBPACK FOOTER //
// ./src/containers/rating/components/question.tsx